const MAX_IMAGE_FILE_SIZES = {
  teams: 20,
  slack: 2,
};
export const imageSizeLimit = (channel: "slack" | "teams"): number => MAX_IMAGE_FILE_SIZES[channel];
